import React from "react";
import IndustrialIoT from "../components/Industries/Industries";
export default function IndustrialIoTPage() {
  return (
    <main>
      <IndustrialIoT />
    </main>
  );
}